import './styles.sass'

import React, { FC } from 'react';

interface IGgInput {
  label?: string;
  onChange: (value: any) => void;
  className?: string;
  inputContainer?: string;
  value?: any;
  type: "text" | "number" | "password" | "email" | "tel" | "date";
  id?: string;
  minLength?: number;
  maxLength?: number;
  required?: boolean;
  placeholder?: string;
  icon?: any;
  style?: any
  disabled?:boolean
}

const Input: FC<IGgInput> = (
  {
    label,
    onChange,
    className,
    inputContainer,
    value,
    type,
    id,
    minLength,
    maxLength,
    required,
    placeholder,
    icon,
    style,
    disabled,
  }) => {

  function setClassNames() {
    const hasIcon = icon ? 'with-icon' : '';
    const hasClassName = inputContainer || ''
    return `${hasIcon} ${hasClassName}`
  }
  return (
    <label htmlFor={id} className={`input ${setClassNames()}`}>
      {label}
      <span className="input-container" style={style}>
        {icon && <span className="icon">{icon}</span>}
        <input
          id={id}
          type={type}
          value={value}
          minLength={minLength && minLength}
          maxLength={maxLength && maxLength}
          required={required ? required : false}
          className={`inputComponent ${className ?? ""}`}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
      </span>
    </label>
  );
};

export default Input;
